import type { Service } from '@/types/content'

/**
 * Services, each belonging to one of the three domains. There is deliberately
 * only one taxonomy on this site: a service is a thing offered *within* a
 * domain, and a project is evidence *of* a domain. Nothing is listed twice
 * under a competing label.
 */
export const services: readonly Service[] = [
  {
    slug: 'ui-ux-design',
    domain: 'design',
    projectSlug: 'autofish-store',
    name: 'UI/UX Design',
    icon: 'atom',
    description:
      'Interface and experience design for web and mobile products, from research and wireframes through to a build-ready Figma system.',
    deliverables: [
      'Research and user flows',
      'Wireframes and prototypes',
      'Design systems and components',
      'Usability testing',
    ],
  },
  {
    slug: 'brand-design',
    domain: 'design',
    projectSlug: 'maguida-ai',
    name: 'Brand Design',
    icon: 'browsers',
    description:
      'Visual identity work: the mark, the palette, the type and the rules that keep a brand consistent everywhere it appears.',
    deliverables: [
      'Logo and visual identity',
      'Brand guidelines',
      'Marketing and social assets',
      'Print and packaging',
    ],
  },
  {
    slug: 'full-stack-development',
    domain: 'software',
    projectSlug: 'e-testing-suite',
    name: 'Full-Stack Development',
    icon: 'browser',
    description:
      'Production web applications in React and Node, with a typed API and a relational database behind them.',
    deliverables: [
      'ReactJS and Tailwind front ends',
      'ExpressJS and GraphQL APIs',
      'PostgreSQL with Prisma',
      'Authentication and integrations',
    ],
  },
  {
    slug: 'cloud-devops',
    domain: 'infrastructure',
    projectSlug: 'checkme',
    name: 'Cloud & DevOps',
    icon: 'archive',
    description:
      'Cloud infrastructure designed, provisioned and automated, so deploys are repeatable and the system is observable.',
    deliverables: [
      'AWS architecture and setup',
      'Docker and container workflows',
      'CI/CD with GitHub Actions',
      'Monitoring with Grafana and Prometheus',
    ],
  },
  {
    slug: 'mobile-apps',
    domain: 'software',
    projectSlug: 'driv',
    name: 'Mobile Apps',
    icon: 'deviceMobile',
    description:
      'Cross-platform applications built from one React codebase and packaged for the stores with Capacitor.',
    deliverables: [
      'React and Capacitor builds',
      'Android release and store listing',
      'Offline and device APIs',
      'Release pipelines',
    ],
  },
  {
    slug: 'networking',
    domain: 'infrastructure',
    projectSlug: 'libroware',
    name: 'Networking',
    icon: 'eye',
    description:
      'Network design and configuration across Cisco, Huawei and Fortinet equipment, from addressing through to perimeter security.',
    deliverables: [
      'Switch and router configuration',
      'Network segmentation',
      'Firewall and VPN setup',
      'Documentation and handover',
    ],
  },
]
